/* import __COLOCATED_TEMPLATE__ from './teammate-participated-filter.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { REPORTING_FILTER_SELECT_ALL } from 'embercom/lib/reporting/flexible/constants';

export default class TeammateParticipatedFilter extends Component {
  @service appService;
  @service intl;
  @service intercomEventService;
  @tracked availableTeammates = this.appService.app.humanAdmins;
  @tracked label = this.currentLabel;
  selectedDropdownItems = this.args.selected.values || [];

  get items() {
    return [
      {
        heading: this.intl.t(
          'components.reporting.custom.chart-builder.filter-bar.teammate-participated-filter.heading',
        ),
        items: this.allItems,
      },
    ];
  }

  get allItems() {
    return this.availableTeammates.map((teammate) => ({
      model: teammate,
      text: teammate.display_as_assignee,
      value: teammate.id.toString(),
      component: 'reporting/flexible/filter-bar/teammate-item',
      isSelected: this.selectedDropdownItems.includes(teammate.id.toString()),
    }));
  }

  get selectedTeammateIds() {
    return this.selectedDropdownItems.filter((item) => item !== REPORTING_FILTER_SELECT_ALL);
  }

  get currentLabel() {
    if (this.selectedTeammateIds.length === 0) {
      return this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.teammate-participated-filter.any-teammate',
      );
    }

    let teammateNames = this.selectedTeammateIds.map((teammateId) => {
      return (
        this.availableTeammates.find((teammate) => teammate.id.toString() === teammateId)
          ?.display_as_assignee ||
        this.intl.t(
          'components.reporting.custom.chart-builder.filter-bar.teammate-participated-filter.former-teammate',
        )
      );
    });
    return teammateNames.join(', ');
  }

  get name() {
    return this.intl.t(
      'components.reporting.custom.chart-builder.filter-bar.teammate-participated-filter.selected-teammate-new',
    );
  }

  get selectAllLabel() {
    return this.intl.t(
      'components.reporting.custom.chart-builder.filter-bar.teammate-participated-filter.select-all-new',
    );
  }

  @action
  onClose() {
    if (this.isDestroying) {
      // for some reason onClose gets triggered when you remove the filter
      // even if the dropdown isn't currently open
      return;
    }

    if (!this.selectedDropdownItems.length) {
      this.selectedDropdownItems = [REPORTING_FILTER_SELECT_ALL];
    }

    this.intercomEventService.trackAnalyticsEvent({
      action: 'filtered_participated_teammate',
      object: this.args.analyticsObject,
      teammate_count: this.selectedTeammateIds.length,
    });

    this.args.setSelected(this.selectedDropdownItems);
    this.label = this.currentLabel;
  }

  @action
  removeFilter() {
    this.selectedDropdownItems = [];
    this.args.removeFilter();
  }
}
